<template>
  <div class="master-container">
    <v-content>
      <v-card flat class="mx-3 mt-2 pa-2">
      </v-card>
    </v-content>
  </div>
</template>

<script>
import MstrHedr from '../modules/MstrHedr'
import MsgList from '../modules/MsgList'
import myAxios from '../../axios/myAxios.js'

export default {
  components: {
    MstrHedr
  },
  data () {
    return {
      userInfo: false,
      listItems: [],
      totalList: 0
    }
  },
  created () {
    // ログインセッションを確認する
    myAxios.get('/api/common/session_manager', {type: 'isLogin'}).then(res => {
      const status = res.data.status
      const result = res.data.result

      // ログインセッションを確認できなければログイン画面に遷移する
      if (!(status && result)) {
        alert(MsgList.MSG_SES_CANNOT_CONFIRM)
        this.$router.push('/')
        this.$store.dispatch('appSetting/fLogin')
      } else {
        this.$store.dispatch('appSetting/tLogin')
      }
    })
  },
  methods: {
  },
  computed: {
  }
}

</script>



// WEBPACK FOOTER //
// src/components/templates/Master.vue